import {
  Box,
  FormControl,
  FormControlLabel,
  makeStyles,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@material-ui/core";
import { find } from "lodash";
import React, { useEffect, useState } from "react";
import AxiosConfigure from "../../Axios.configure";
import UseFetchSellerStore from "../../Services/UseFetchSellerStore";
const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2),
  },
  addressListItem: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    margin: "0 !important",
    padding: "10px 0",
    "&:last-child": {
      borderBottom: 0,
    },
  },
}));
const BranchAddress = ({ closeSidenav }) => {
  const { data, isLoading } = UseFetchSellerStore(true);
  console.log(data)
  const classes = useStyles();
  const [selectedAddressId, setselectedAddressId] = useState("");
  const [SearchText, setSearchText] = useState("");
  useEffect(() => {
    const selectedBranch = AxiosConfigure.getSelectedBranch();
    if (selectedBranch) {
      setselectedAddressId(selectedBranch.id.toString());
    }
  }, []);

  const handleChange = (event) => {
    setselectedAddressId(event.target.value);
    const selectedData = find(
      data,
      (o) => o.id === event.target.value
    );
    AxiosConfigure.setSelectedBranch(selectedData);
    closeSidenav();
  };
  const HandleSearchText = (ev) => {
    setSearchText(ev.target.value);
  };
  return (
    <Box width="100%">
      <TextField
        value={SearchText}
        onChange={HandleSearchText}
        fullWidth
        placeholder="Search Store by Branch Name"
      />
      {!data.filter((d) => {
        const regex = new RegExp(SearchText, "gi");
        return d.address.match(regex);
      }).length && (
        <Typography align="center" className={classes.root}>
          No results
        </Typography>
      )}
      {isLoading ? (
        ""
      ) : (
        <FormControl className={classes.root} component="fieldset">
          <RadioGroup
            value={selectedAddressId}
            aria-label="address"
            name="address-select"
            onChange={handleChange}
          >
            {data
              .filter((d) => {
                const regex = new RegExp(SearchText, "gi");
                return d.address.match(regex);
              })
              .map((address) => (
                <FormControlLabel
                  className={classes.addressListItem}
                  key={address.id}
                  value={address.id}
                  control={<Radio />}
                  label={
                    <Box>
                      {address.ame || address.name ? (
                        <Box display="flex">
                          {address.name && (
                            <Typography gutterBottom>
                              <b>{address.name}</b>
                            </Typography>
                          )}
                        </Box>
                      ) : null}
                      <Typography gutterBottom title={address.address}>
                        {address.address}
                        {address.address &&
                        address.address.slice(-1) === ","
                          ? " "
                          : ", "}
                        {address.locality}
                        {address.locality && address.locality.slice(-1) === ","
                          ? " "
                          : ", "}
                      </Typography>
                      <Typography gutterBottom>
                        {address.city}
                        {address.city && address.city.slice(-1) === ","
                          ? " "
                          : ", "}
                        {address.district}
                        {address.district && "- "}
                        {address.pinCodeId}
                        {address.pinCodeId &&
                        address.pinCodeId.slice(-1) === ","
                          ? " "
                          : ", "}
                        {address.region}
                        {address.region && address.region.slice(-1) === ","
                          ? " "
                          : ", "}
                        {address.country}
                        {address.country && "."}
                      </Typography>
                      {address.mobileNo && (
                        <Typography gutterBottom>
                          <b>Phone: </b>
                          {address.mobileNo}
                        </Typography>
                      )}
                    </Box>
                  }
                />
              ))}
          </RadioGroup>
        </FormControl>
      )}
    </Box>
  );
};

export default BranchAddress;
